export default "__VITE_ASSET__CFXkebaN__"